<template>
  <div class="nav">
    <el-menu
      router
      class="el-menu-demo"
      mode="horizontal"
      :default-active="$route.path"
      @select="handleSelect"
    >
      <el-menu-item index="/">报纸题名</el-menu-item>
      <el-menu-item index="/information">报纸卷号</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      index: "/"
    };
  },

  props: ["title"],
  props: {
    title: String
  },
  methods: {
    handleSelect(key, keyPath) {
      this.index = key;
    }
  },
  created() {
    this.index = this.title;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav {
  width: 100%;
  height: auto;
  background-color: #2f4240;
}
.el-menu.el-menu--horizontal {
  width: 1200px;
  background-color: #2f4240;
  margin: 0px auto;
  color: #fff;
}
.el-menu-item {
  width: calc(100% / 10);
  text-align: center;
  font-size: 15px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border: none;
  border-top: 2px solid #eb4f39;
  color: #eb4f39;
  background-color: #fff;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #fff;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #eb4f39;
  color: #eb4f39;
  background-color: #fff;
}
.el-menu--horizontal > .el-menu-item {
  color: #fff;
}
.el-menu.el-menu--horizontal {
  border: none;
}
</style>
